import { render, staticRenderFns } from "./priceEchart.vue?vue&type=template&id=564a2b04&scoped=true"
import script from "./priceEchart.vue?vue&type=script&lang=js"
export * from "./priceEchart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564a2b04",
  null
  
)

export default component.exports